import { Card, InfoRow } from './BmsCardPrimitives'

const CycleInfoCard = ({ bms, className = '' }) => (
  <Card className={className}>
    <InfoRow label="Cycle count" value={bms.cycleCount} />
    <InfoRow label="Charge cycle" value={bms.chargeCycle} />
    <InfoRow label="Discharge cycle" value={bms.dischargeCycle} />
  </Card>
)

export default CycleInfoCard
